import React, {FunctionComponent, ReactHTMLElement, DetailedHTMLProps, HTMLAttributes} from "react";

interface SelectProps extends DetailedHTMLProps<React.SelectHTMLAttributes<HTMLSelectElement>, HTMLSelectElement> {
  className?: string;
  label?: string;
}

const Select: FunctionComponent<SelectProps> = ({children, className, label, ...rest}) => {
  return (
    <div className={`flex flex-col${className ? ' ' + className : ''}`}>
      {
        label &&
        <label className='mb-1 pl-2 text-gray-600'>{label}</label>
      }
      <div className='bg-white block border border-gray-400 hover:border-gray-500 px-1 rounded shadow w-full'>
        <select className='bg-transparent block w-full leading-tight focus:outline-none focus:shadow-outline py-2' {...rest}>
          {children}
        </select>
      </div>
    </div>
  )
}

export default Select;
